import {configureStore} from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import {persistReducer} from "redux-persist";
import {combineReducers} from "@reduxjs/toolkit";
import {persistStore} from "redux-persist";

import {UIReducer} from "./slices/UISlice";
import {stepperInfoReducer} from "./slices/stepperInfoSlice";
import {registrationCleanerReducer} from "./slices/registrationCleanerSlice";
import {feedbackCustomerReducer} from "./slices/feedbackCustomerSlice";
import {feedbackCleanerReducer} from "./slices/feedbackCleanerSlice";
import {userDetailsReducer} from "./slices/userDetailsSlice";
import {modalPreviewSelectedPhotoReducer} from "./slices/modalPreviewSelectedPhotoSlice";
import {servicePackagesReducer} from "./slices/servicePackagesSlice";
import {additionalServicesReducer} from "./slices/additionalServicesSlice";
import {cleanerDetailsReducer} from "./slices/cleanerDetailsSlice";
import {orderReducer} from "./slices/orderSlice";
import {cleaningRequestsReducer} from "./slices/cleaningRequestsSlice";
import {offerReducer} from "./slices/offerSlice";
import {serviceTypesReducer} from "./slices/serviceTypesSlice";
import {filtersForCleanerReducer} from "./slices/filtersForCleanerSlice";
import {cleanerApplicationsReducer} from "./slices/cleanerApplicationsSlice";
import {filtersForCustomerReducer} from "./slices/filtersForCustomerSlice";
import {qrCodeReducer} from "./slices/qrCodeSlice";
import {supportReducer} from "./slices/supportSlice";

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
}

const reducer = combineReducers({
    UI: UIReducer,
    stepperInfo: stepperInfoReducer,
    registrationCleaner: registrationCleanerReducer,
    feedbackCustomer: feedbackCustomerReducer,
    feedbackCleaner: feedbackCleanerReducer,
    userDetails: userDetailsReducer,
    cleanerDetails: cleanerDetailsReducer,
    order: orderReducer,
    servicePackages: servicePackagesReducer,
    serviceTypes: serviceTypesReducer,
    filtersForCleaner: filtersForCleanerReducer,
    filtersForCustomer: filtersForCustomerReducer,
    cleanerApplications: cleanerApplicationsReducer,
    additionalServices: additionalServicesReducer,
    modalPreviewSelectedPhoto: modalPreviewSelectedPhotoReducer,
    cleaningRequests: cleaningRequestsReducer,
    offer: offerReducer,
    qrCode: qrCodeReducer,
    support: supportReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
   reducer: persistedReducer,
});

export const persistor = persistStore(store);

